import React, { useState } from "react";
import styled from "@emotion/styled";

export const CopyToClipboard = ({ textToCopy = "Text to copy", message = "Click to copy", buttonText = "Copy", preventCopyEvent }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <CopyToClipbeardContainer>
      <CopyText>{message}</CopyText>
      <CopyButton
        onClick={preventCopyEvent ? preventCopyEvent : copyToClipboard}
        copied={copied}
        aria-live="polite"
      >
        {copied ? "Copied!" : buttonText}
      </CopyButton>
    </CopyToClipbeardContainer>
  );
};

const CopyToClipbeardContainer = styled.div`
  background-color: #f5f5f5;
  padding: 10px 15px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  @media (min-width: 600px) {
    margin-top: 25px;
    margin-bottom: 25px;
  }
`;

const CopyText = styled.div`
  flex: 1;
  font-weight: 600;
`;

const CopyButton = styled.button`
  background-color: ${({ copied }) => (copied ? "black" : "white")};
  color: ${({ copied }) => (copied ? "white" : "black")};
  padding: 8px 20px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.8rem;
  border: none;
  margin-left: 10px;
  cursor: pointer;
  transition: background 0.3s cubic-bezier(0.4,0,0.2,1), color 0.3s cubic-bezier(0.4,0,0.2,1), transform 0.2s cubic-bezier(0.4,0,0.2,1);
  transform: ${({ copied }) => (copied ? "scale(1.08)" : "scale(1)")};
  box-shadow: ${({ copied }) => (copied ? "0 2px 12px 0 rgba(0,0,0,0.10)" : "none")};
  @media (min-width: 600px) {
    font-size: 1rem;
  }
`;